/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Invoice_TotalInputs */

const en_inbound_field_invoice_total = /** @type {(inputs: Inbound_Field_Invoice_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice total`)
};

/**
* | output |
* | --- |
* | "Invoice total" |
*
* @param {Inbound_Field_Invoice_TotalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_invoice_total = /** @type {((inputs?: Inbound_Field_Invoice_TotalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Invoice_TotalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_invoice_total(inputs)
});